export { default } from './WistiaEmbed'
